import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import { setChannelSlot } from '@/lib/api/products'

interface SetSlotInput {
  channelId: string
  slot: number
  asset_id: string
  alt_text?: string
  custom_filename?: string
}

export function useChannelSlotMutation(productId: string) {
  const qc = useQueryClient()
  const { t } = useTranslation()
  return useMutation({
    mutationFn: async (input: SetSlotInput) => {
      const { channelId, slot, ...body } = input
      const result = await setChannelSlot(productId, channelId, slot, body)
      if (!result.success) {
        throw new Error(result.error || 'set_channel_slot_failed')
      }
      return result
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['product-channel-assets', productId] })
      toast.success(t('remakeApply.media.appliedToast', { count: 1 }))
    },
    onError: (err: unknown) => {
      const msg = err instanceof Error ? err.message : 'unknown error'
      toast.error(msg)
    },
  })
}
